module.exports = __webpack_public_path__ + "static/media/025.83748306.jpg";